import { memo } from 'react';

import { cn } from '../../lib/styles';

interface CardAlertProps extends React.ComponentProps<'div'> {
  children: React.ReactNode;
}

interface CardAlertHeaderProps {
  icon: React.ReactNode;
  title: string;
  actions?: React.ReactNode;
}

export const CardAlertHeader = ({ icon, title, actions }: CardAlertHeaderProps) => {
  return (
    <div className="py-3 pl-3 pr-2 bg-gray-2 gap-4 flex items-center justify-between border-b border-border-default">
      <div className="flex items-center gap-2">
        {icon}

        <div className="font-heading-l font-semibold text-text-primary">{title}</div>
      </div>

      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
};

interface CardAlertContentProps extends React.ComponentProps<'div'> {
  children: React.ReactNode;
}

export const CardAlertContent = ({ children, className, ...rest }: CardAlertContentProps) => {
  return (
    <div className={cn('p-3 bg-bg-sur-primary', className)} {...rest}>
      {children}
    </div>
  );
};

const CardAlertBase = ({ children, className, ...rest }: CardAlertProps) => {
  return (
    <div
      className={cn('flex flex-col border border-border-default rounded-[16px] overflow-hidden', className)}
      {...rest}
    >
      {children}
    </div>
  );
};

export const CardAlert = memo(CardAlertBase);
